import {JsonProperty} from '@outfoxx/jackson-js';
import {FilterInterface} from './FilterInterface';
import {FilterValueInterface} from 'modules/spravochnik/dt-front-page-generator/src/Entity/Filter/Value/FilterValueInterface';

export abstract class AbstractFilter<TValue extends FilterValueInterface> implements FilterInterface<TValue> {
    @JsonProperty({value: 'id'})
    private readonly _id: string;

    @JsonProperty({value: 'label'})
    private readonly _label: string;

    constructor(id: string, label: string) {
        this._id = id;
        this._label = label;
    }

    get id(): string {
        return this._id;
    }

    get label(): string {
        return this._label;
    }

    hasValue(): boolean {
        return this.value !== null;
    }

    abstract get value(): TValue|null;

    abstract reset(): void;
}
